// Varlık türüne göre etiketler (Ev / Araba)
export const ASSET_LABELS = {
  ev: {
    name: "Ev",
    financing: "Finansman Tutarı",
    downPayment: "Proje Peşinatı",
    heading: "Ev Ödeme Planınızı Oluşturun",
  },
  araba: {
    name: "Araç",
    financing: "Araç Bedeli",
    downPayment: "Araç Peşinatı",
    heading: "Araç Ödeme Planınızı Oluşturun",
  },
};

export function getLabels(assetType) {
  return ASSET_LABELS[assetType] || ASSET_LABELS.ev;
}
